import type { RouteRecordRaw } from 'vue-router';
import { isLoading, isAuthenticated, redirectNotificationsCenter } from '@/router/guards';
import myOrgCompany from '@/router/routes/private/my-org-company';
import mySplCompany from '@/router/routes/private/my-spl-company';
import myUsrCompany from '@/router/routes/private/my-usr-company';
import account from '@/router/routes/private/account';
import sicuraSolutionmyOrgCompany from '@/router/routes/private/sicuraSolution/my-org-company';
import sicuraSolutionmySplCompany from '@/router/routes/private/sicuraSolution/my-spl-company';
import sicuraSolutionmyUsrCompany from '@/router/routes/private/sicuraSolution/my-usr-company';
import sicuraSolutionAccountRoutes from '@/router/routes/private/sicuraSolution/account';

export const privateRoutes: Array<RouteRecordRaw> = [
  {
    path: '/logout',
    name: 'Logout',
    component: () => import('@/views/private/Logout.vue'),
    beforeEnter: [isLoading, isAuthenticated],
  },

  {
    path: '/redirect',
    name: 'Redirect',
    component: () => import('@/views/private/Redirect.vue'),
    beforeEnter: [isLoading, isAuthenticated],
  },

  {
    path: '/private',
    component: () => import('@/views/Private.vue'),
    beforeEnter: [isLoading, isAuthenticated],
    children: [
      {
        path: 'launcher',
        name: 'Launcher',
        component: () => import('@/views/private/Launcher.vue'),
      },
      {
        path: 'notifications-center',
        name: 'NotificationsCenter',
        component: () => import('@/views/private/NotificationsCenter.vue'),
      },
      myOrgCompany,
      mySplCompany,
      myUsrCompany,
      account,
    ],
  },

  {
    path: '/private/buildings/:id/condominium-site/auth',
    name: 'CondominiumSiteAuth',
    component: () => import('@/views/private/CondominiumSiteAuth.vue'),
    beforeEnter: [isLoading, isAuthenticated],
  },

  {
    path: '/sicura-solution',
    beforeEnter: [isLoading, isAuthenticated],
    children: [
      {
        path: 'logout',
        name: 'SicuraSolutionLogout',
        component: () => import('@/views/private/Logout.vue'),
      },

      {
        path: 'redirect',
        name: 'SicuraSolutionRedirect',
        component: () => import('@/views/private/Redirect.vue'),
      },

      {
        path: 'private',
        component: () => import('@/views/Private.vue'),
        children: [
          {
            path: 'launcher',
            name: 'SicuraSolutionLauncher',
            component: () => import('@/views/private/Launcher.vue'),
          },
          {
            path: 'notifications-center',
            name: 'SicuraSolutionNotificationsCenter',
            component: () => import('@/views/private/NotificationsCenter.vue'),
          },
          sicuraSolutionmyOrgCompany,
          sicuraSolutionmySplCompany,
          sicuraSolutionmyUsrCompany,
          sicuraSolutionAccountRoutes,
        ],
      },
    ],
  },

].map((route) => ({ ...route, beforeEnter: [...route.beforeEnter, redirectNotificationsCenter] }));
